/**
 * insertAtIndex
 * Inserts an item into an array at the specified index and returns the modified array.
 * @template T - The type of the array elements.
 * @param {T[]} array - The array to modify.
 * @param {number} index - The index at which to insert the item.
 * @param {T} item - The item to insert into the array.
 * @returns {T[]} The modified array with the item inserted at the specified index.
 */
export function insertAtIndex<T>(props: {
    array: T[];
    index: number;
    item: T;
}): T[] {
    const { array, index, item } = props;

    return array.slice(0, index).concat(item, array.slice(index));
}
